import { ShieldCheck, Trophy, Handshake, Megaphone } from "lucide-react";
import { IMAGES } from "../data/content";
import { PageHero } from "../components/shared/PageHero";
import { Reveal } from "../components/shared/Reveal";
import { SectionHead } from "../components/shared/SectionHead";
import { PrimaryButton } from "../components/shared/Buttons";

const MODEL = [
  {
    icon: ShieldCheck,
    title: "You keep technical authority",
    text: "Each participating organisation remains fully responsible for the technical management of its own sport — competition rules, officiating standards, divisions and sport-specific requirements.",
  },
  {
    icon: Trophy,
    title: "We build the stage",
    text: "Kumite Games provides the overall event platform — venue experience, presentation, promotion and the multi-sport environment that puts your art in front of a national audience.",
  },
  {
    icon: Handshake,
    title: "A true partnership",
    text: "Kumite Games does not replace governing bodies. It works alongside them, so every discipline is represented with authenticity, respect and proper governance.",
  },
  {
    icon: Megaphone,
    title: "Grow your community",
    text: "Stand alongside the other founding arts, introduce your discipline to new athletes and families, and be part of a new national tradition.",
  },
];

export default function Federations() {
  return (
    <>
      <PageHero
        eyebrow="Federations & Organisations"
        title="Guardians of the Arts"
        intro="Kumite Games is being built alongside recognised martial arts organisations and governing bodies. Your discipline keeps its identity, rules and technical authority — we provide the national stage."
        image={IMAGES.judo}
        testId="federations-page-hero"
      />
      <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
        <SectionHead
          eyebrow="The Partnership Model"
          title="How Kumite Games works with organisations"
          testId="partnership-model-heading"
        />
        <div className="grid gap-5 sm:grid-cols-2">
          {MODEL.map((m, i) => (
            <Reveal
              key={m.title}
              delay={i * 0.1}
              className="spotlight-card clip-notch border border-white/5 bg-ink-soft p-8 sm:p-10"
            >
              <m.icon className="h-7 w-7 text-gold" />
              <h3 className="mt-6 font-head text-lg font-bold uppercase tracking-wide text-bone">
                {m.title}
              </h3>
              <p className="mt-4 text-sm leading-relaxed text-slate-400">{m.text}</p>
            </Reveal>
          ))}
        </div>
      </section>
      <section className="relative overflow-hidden border-t border-white/5">
        <div className="absolute inset-0 -z-10 bg-[radial-gradient(700px_circle_at_50%_50%,rgba(220,38,38,0.1),transparent_60%)]" />
        <div className="mx-auto max-w-4xl px-5 py-24 text-center sm:px-8 sm:py-32">
          <Reveal>
            <h2 data-testid="federations-cta-heading" className="font-display text-5xl uppercase leading-[0.9] tracking-tight text-bone sm:text-6xl">
              Interested in bringing your <span className="text-kred">martial art</span> to Kumite Games?
            </h2>
            <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-slate-400">
              We welcome conversations with national federations, associations and established
              martial arts organisations across New Zealand.
            </p>
            <div className="mt-10">
              <PrimaryButton to="/contact" testId="federations-contact-button">
                Contact Kumite Games
              </PrimaryButton>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
